import { t } from "@lingui/macro"
import { useMemo } from "react"

import { IStatusChipProps, StatusChip } from "src/components/StatusChip"
import { ICommunityStatusChipProps } from "src/views/community-posts-and-comments/components/CommunityStatusChip/types"
import { COMMUNITY_POST_STATUS_CHIP_LABELS } from "src/views/community-posts-and-comments/constants"
import { CommunityPostStatus } from "src/views/community-posts-and-comments/types"

export const CommunityStatusChip = ({ status }: ICommunityStatusChipProps) => {
    const chipProps = useMemo((): IStatusChipProps => {
        switch (status) {
            case CommunityPostStatus.PUBLISHED:
                return {
                    state: "positive",
                    label: COMMUNITY_POST_STATUS_CHIP_LABELS[
                        CommunityPostStatus.PUBLISHED
                    ].name,
                }
            case CommunityPostStatus.SCHEDULED:
                return {
                    state: "neutral",
                    label: COMMUNITY_POST_STATUS_CHIP_LABELS[
                        CommunityPostStatus.SCHEDULED
                    ].name,
                }
            default:
                return {
                    state: "other",
                    label: t`community-posts-view.status-chip-unknown-status`,
                }
        }
    }, [status])

    return <StatusChip {...chipProps} />
}
